module.exports = __webpack_public_path__ + "img/china-petroleum-bg-icon.62b93cab.png";